import React, { useContext, useEffect } from 'react';
import Context from "../context/context";

import { checkString, checkArray } from '../helpers/global'
import { DateTime } from 'luxon';

const Performances = React.lazy(() => import('./performances/Performances'));


const Event = props => {
  const { activeFilters } = useContext(Context);
  const { data, filterView } = props;
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};

  if (checkArray(data.image_data)) {
    img_src = data.image_data.toString();
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)) {
    focal_point = data.focal_point;
    combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  let date = "";
  if (checkString(data.date_formatted)) {
    date = "Dates: " + data.date_formatted;
  }

  if (typeof activeFilters["top_filter"] !== "undefined") {
    if (activeFilters["top_filter"].value !== "all" && activeFilters["top_filter"].name === "daily") {
      const top_filter = activeFilters["top_filter"];


      date = top_filter.options.find((f) => f.value === top_filter.value);
      if (typeof date !== "undefined") {
        const selected_date = DateTime.fromSeconds(date.value, { zone: 'Europe/London' }).toFormat('d LLLL');

        date = "Select a time to book tickets for " + selected_date;

      }



    }
  }




  useEffect(() => {

    if (typeof window.gdVideo != "undefined") {
      window.gdVideo();
    }
  }, []);



  return (



    <div className="slot play-container has-modal " >
      <div className="modal embed" >
        <div className="modal-actions">
          <button className="close-modal button button-white">
            Close
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 1.62891L1.25601 14.3729" stroke="black" stroke-width="2" />
              <path d="M1 1.62891L13.744 14.3729" stroke="black" stroke-width="2" />
            </svg>
          </button>
        </div>
        <div className="modal-inner">
          <div className="slot-iframe embed-container fill-container"></div>
        </div>
      </div>

      {checkString(img_src) &&

        <div className="slot-image">
          <div className="image-container">
            <div className="tags">
              {checkString(data.slot_tag) &&
                <div className="tag ">{data.slot_tag}</div>
              }
            </div>
            <img loading="lazy" srcset={img_src} alt={img_alt} style={combiStyle} />

            {data.embed_id.length > 0 &&
              <div className="play-video play-embed" data-id={data.embed_id} data-host={data.embed_host} aria-label="Play video">
                <svg xmlns="http://www.w3.org/2000/svg" width="196" height="222" viewBox="0 0 196 222" fill="none">
                  <path d="M7.50001 12.8666L180.78 111L7.50001 209.133L7.50001 12.8666Z" fill="white" fill-opacity="0.5" stroke="white" stroke-width="15" />
                </svg>
              </div>
            }

          </div>
        </div>
      }
      <div className="slot-content">
        <div className="slot-title font-m font-title">
          {data.title}
          {checkString(data.age_rating_class) &&
            <span className={"age-rating r-" + data.age_rating_class}></span>
          }
        </div>

        {checkString(data.price_from) &&
          <div className="slot-info slot-price" dangerouslySetInnerHTML={{ __html: data.price_from }} />
        }
        {checkString(data.duration) &&
          <div className="slot-info slot-duration" dangerouslySetInnerHTML={{ __html: "Duration: " + data.duration }} />
        }
        {checkString(data.venue) &&
          <div className="slot-info slot-venue" dangerouslySetInnerHTML={{ __html: data.venue }} />
        }
        <div className="slot-bottom">
          <div className="slot-date font-title ">{date}</div>

          <div className="button-wrapper">

            <Performances hash={data.hash} data={data} />

            <a className="button button-black-border" href={data.url}>
              {data.link_title}
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">

                <path class="fill-bg" d="M0.300781 0H12.3008V12H0.300781V0Z" fill="black" />
                <path class="fill" d="M0.300781 0V-1H-0.699219V0H0.300781ZM12.3008 0H13.3008V-1H12.3008V0ZM12.3008 12V13H13.3008V12H12.3008ZM0.300781 12H-0.699219V13H0.300781V12ZM0.300781 1H12.3008V-1H0.300781V1ZM11.3008 0V12H13.3008V0H11.3008ZM12.3008 11H0.300781V13H12.3008V11ZM1.30078 12V0H-0.699219V12H1.30078Z" fill="black" />
                <path class="stroke" d="M4.72882 3.17157L7.55724 6L4.72882 8.82843" stroke="white" stroke-width="1.5" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>


  )
}

export default Event;
